export enum Direction {
  Row = 'row',
  Column = 'column',
}
